module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-2-3-87053fc3306ec107a4775a2ca0fab9b2.jpg";